/* eslint-disable camelcase */
export const CONSTANT = {
  KEYS: {
    USER_STATUS: {
      PENDING_APPROVAL: 'PENDING_APPROVAL',
      APPROVED: 'APPROVED'
    },
    ROLES: {
      ADMIN: 'ADMIN',
      SALES_REP: 'SALES_REP',
      ORDER_FULFILLMENT: 'ORDER_FULFILLMENT',
      PROPOSAL_HOUSE: 'PROPOSAL_HOUSE',
      SALES_MANAGER: 'SALES_MANAGER',
      SALES_SUPPORT: 'SALES_SUPPORT',
      ADMIN_TIME_TRACKING: 'ADMIN_TIME_TRACKING',
      MANAGER_TIME_TRACKING: 'MANAGER_TIME_TRACKING',
      TEAM_MEMBER_TIME_TRACKING: 'TEAM_MEMBER_TIME_TRACKING'
    },
    CHANNELS: {
      SBS: 'SBS',
      BSE_BSW: 'BSE BSW',
      LSS: 'LSS',
      TAM: 'TAM',
      BCX: 'BCX',
      TIP_SALES: 'TIP SALES',
      BCX_CARE: 'BCX_CARE',
      BCX_HD: 'BCX_HD',
      DEALER: 'DEALER',
      INKEROS: 'INKEROS',
      INKEROS_EAST: 'INKEROS_EAST',
      ISS: 'ISS',
      ISS_EAST: 'ISS_EAST',
      LTS: 'LTS',
      NGM: 'NGM',
      NGM_TECHS: 'NGM_TECHS',
      TQ: 'TQ',
      ISS_CMB: 'ISS CMB',
      FIELDS_SALES_WEST: 'FIELDS SALES WEST',
      ADT: 'ADT',
      HEALTH: 'Health',
      CSD: 'CSD',
      NBD: 'NBD',
      CORP_STORE: 'CORP_STORE',
      SMB_INDIRECT_SALES_OTHER: 'SMB Indirect Sales - Other',
      SMB_INDIRECT_SALES_TAG: 'SMB Indirect Sales - TAG',
      SMB_INDIRECT_SALES_ELITE_PROMOTIONS:
        'SMB Indirect Sales - Elite Promotions',
      SMB_INDIRECT_SALES_CORPO_SOLUTION: 'SMB Indirect Sales- CORPO SOLUTION',
      SMB_INDIRECT_SALES_CBTELECOM: 'SMB Indirect Sales- CBTELECOM',
      SMB_INDIRECT_SALES_IDS: 'SMB Indirect Sales- IDS',
      SMB_INDIRECT_SALES_MSG_CONSULTING: 'SMB Indirect Sales- MSG CONSULTING',
      SMB_INDIRECT_SALES_CONNEXION_FK: 'SMB Indirect Sales- CONNEXION FK',
      SMB_INDIRECT_SALES_REVOLVE: 'SMB Indirect Sales- REVOLVE',
      SMB_INDIRECT_SALES_GET_INSTINCTIVE: 'SMB Indirect Sales- GET INSTINCTIVE',
      SMB_INDIRECT_SALES_TOPS_TECH: 'SMB Indirect Sales- TOPS TECH',
      SMB_INDIRECT_SALES_OUTPUT: 'SMB Indirect Sales- OUTPUT',
      SMB_INDIRECT_SALES_ATMOS_MANAGEMENT:
        'SMB Indirect Sales- ATMOS MANAGEMENT',
      SMB_INDIRECT_SALES_KOLLABB: 'SMB Indirect Sales- KOLLABB',
      SMB_INDIRECT_SALES_UP_SYSTEMS: 'SMB Indirect Sales- UP SYSTEMS',
      SMB_INDIRECT_SALES_WATCHDOG: 'SMB Indirect Sales- WATCHDOG',
      SBS_DIRECT_SALES_AB: 'SBS_DIRECT_SALES_AB',
      SBS_DIRECT_SALES_BC: 'SBS_DIRECT_SALES_BC',
      SBS_DIRECT_SALES_EAST: 'SBS_DIRECT_SALES_EAST',
      SMB_TI_GROWTH_NATIONAL: 'SMB TI Growth National',
      AllianceIT: 'AllianceIT',
      SMB_Retention_Sales_WEST: 'SMB Retention Sales WEST',
      SMB_Growth_Sales_W_1E: 'SMB Growth Sales W 1E',
      SMB_TDE_Growth_West: 'SMB TDE Growth West',
      SMB_TDE_Growth_East: 'SMB TDE Growth East',
      SMB_TDE_Nesting_India: 'SMB TDE Nesting India',
      SMB_TDE_Nesting_Morocco: 'SMB TDE Nesting Morocco',
      SMB_Growth_Sales_W_2E: 'SMB Growth Sales W 2E',
      SMB_Penny_Sales_West: 'SMB Penny Sales West',
      'SMB TDE 30+ Retention': 'SMB TDE 30+ Retention'
    },
    DEALERSHIPS: {
      BRAVAD_TECHNOLOGIE: 'Bravad Technologie',
      FIBRE_OPTIC_DROP_ALLOWED_DEALERS: [
        'Communication Zone Inc',
        'Smart-Cell Communications',
        'Master Com (Koodo)'
      ]
    },
    REQUIRES_ORDER_ACCESS: {
      YES: 'yes',
      NO: 'no'
    }
  },
  ROLES: {
    ADMIN: 1,
    SALES_REP: 2,
    ORDER_FULFILLMENT: 3,
    PROPOSAL_HOUSE: 6,
    SALES_MANAGER: 7,
    SALES_SUPPORT: 11
  },
  CHANNELS: {
    DEALER_ADT: 0,
    CORP_STORE: 0,
    SBS: 0,
    BSE_BSW: 0,
    LSS: 0,
    TAM: 0,
    ADT_SALES: 0,
    TIP_SALES: 0,
    DEALER: 0
  },
  DASHBOARD_LABELS: {
    SALES_REP_DASHBOARD: 'My Orders',
    CC_SALES_REP_DASHBOARD: 'Sales Rep Dashboard',
    SOV_DASHBOARD: 'Order Fulfillment Dashboard',
    QUOTE_APPROVAL_DASHBOARD: 'Quote Approval Dashboard',
    BA_SALES_REP_DASHBOARD: 'My Orders',
    IOT_SALES_REP_DASHBOARD: 'My Orders',
    BA_ORDER_FULFILLMENT_DASHBOARD: 'Order Fulfillment Dashboard',
    IOT_SOV_DASHBOARD: 'Order Fulfillment Dashboard'
  }
};

export const RECAPTCHA_SITE_KEY = '6LeDZq4ZAAAAAPrApKRb5v9UFb7_nd09kiY_S8hJ';

export const ROLES = ['SALES_REP', 'SALES_REP', 'SOV_AGENT', 'SRT_GROUP'];

export const channels = [
  {
    text: 'SBS',
    value: 'SBS'
  },
  {
    text: 'Fields Sales West',
    value: 'FIELDS_SALES_WEST'
  },
  {
    text: 'BSE_BSW',
    value: 'BSE_BSW'
  },
  {
    text: 'LSS',
    value: 'LSS'
  },
  {
    text: 'TAM',
    value: 'TAM'
  },
  {
    text: 'TIP Sales',
    value: 'TIP_SALES'
  },
  {
    text: 'BCX',
    value: 'BCX'
  },
  {
    text: 'BCX Care',
    value: 'BCX_CARE'
  },
  {
    text: 'BCX HD',
    value: 'BCX_HD'
  },
  {
    text: 'Dealer',
    value: 'DEALER'
  },
  {
    text: 'Inkeros',
    value: 'INKEROS'
  },
  {
    text: 'Inkeros East',
    value: 'INKEROS_EAST'
  },
  {
    text: 'ISS',
    value: 'ISS'
  },
  {
    text: 'ISS CMB',
    value: 'ISS_CMB'
  },
  {
    text: 'ISS East',
    value: 'ISS_EAST'
  },
  {
    text: 'LTS',
    value: 'LTS'
  },
  {
    text: 'NGM',
    value: 'NGM'
  },
  {
    text: 'NGM Techs',
    value: 'NGM_TECHS'
  },
  {
    text: 'TQ',
    value: 'TQ'
  }
];

export const profileKeysToList = [
  'name',
  'email',
  'role_id',
  'channelName',
  'dealership',
  'outlet',
  'cpms_id',
  'sales_manager',
  'sales_manager_email'
];

export const businessConnectContactCentreOnlineTool =
  'Contact_Centre_Online_Tool';
export const businessConnectContactCentreLandingPage = 'Contact_Centre_Landing';
export const businessConnectQuoteToolOrderCategoryName =
  'TELUS_Business_Connect_Quote_Tool_Order_Form';
export const businessAppsCategoryName = 'TELUS_Business_Apps';
export const iotCategoryName = 'TELUS_IOT';
export const iotPrequalificationForm = 'IoT_Prequalification';
export const iotOrderForm = 'IoT_Order_Form';
export const isBusinessConnectQuoteTool = 'Business_Connect_Quote_Tool';

export const businessAppsPrequalificationForm = 'Business_App_Prequalification';
export const businessAppsOrderForm = 'Business_App_Order_Form';
export const constactCentreCategoryName =
  'TELUS_Business_Connect_Contact_Centre_&_Professional_Services';
export const businessConnectQuoteToolForm = 'Business_Connect_Quote_Tool';
export const orderDetailsForm = 'Order_Details';
export const orderSummaryForm = 'Order_Summary';
export const prequalificationForm = 'prequalification';
export const isChannelDealer = 'Dealer';
export const fieldDealerNote = 'dealerNote';
export const fieldInstallationNote = 'installationNote';
export const fieldApprovalCodeWhiteGlove = 'approvalCodeWhiteGlove';
export const orderStatus = {
  incomplete: 'INCOMPLETE',
  pendingValidation: 'PENDING_VALIDATION',
  validated: 'ORDER_VALIDATED',
  revisionRequired: 'REVISION_REQUIRED',
  waitingOnCredit: 'WAITING_ON_CREDIT',
  waitingOnSales: 'WAITING_ON_SALES',
  contractSigned: 'CONTRACT_SIGNED',
  contractSent: 'CONTRACT_SENT',
  orderCanceled: 'ORDER_CANCELED',
  withConcierge: 'WITH_CONCIERGE',
  contractExpired: 'CONTRACT_EXPIRED',
  implementationInProgress: 'IMPLEMENTATION_IN_PROGRESS',
  waitingOnCompletionCall: 'WAITING_ON_COMPLETION_CALL',
  orderInstalled: 'ORDER_INSTALLED',
  orderPlaced: 'ORDER_PLACED',
  orderActivated: 'ORDER_ACTIVATED',
  orderShipped: 'ORDER_SHIPPED',
  orderCompleted: 'ORDER_COMPLETED',
  orderSubmitted: 'ORDER_SUBMITTED'
};

export const statusMap = {
  INCOMPLETE: 'Order Incomplete',
  PENDING_VALIDATION: 'Pending Validation',
  ORDER_VALIDATED: 'Validated',
  REVISION_REQUIRED: 'Revision Required',
  WAITING_ON_CREDIT: 'Waiting On Credit',
  WAITING_ON_SALES: 'Waiting On Sales',
  CONTRACT_SIGNED: 'Contract Signed',
  CONTRACT_SENT: 'Contract Sent',
  ORDER_CANCELED: 'Order Canceled',
  WITH_CONCIERGE: 'With Concierge',
  CONTRACT_EXPIRED: 'Contract Expired',
  IMPLEMENTATION_IN_PROGRESS: 'Implementation In Progress',
  WAITING_ON_COMPLETION_CALL: 'Waiting On Completion Call',
  ORDER_INSTALLED: 'Order Installed',
  ORDER_PLACED: 'Order Placed',
  ORDER_ACTIVATED: 'Order Activated',
  ORDER_SHIPPED: 'Order Shipped',
  ORDER_COMPLETED: 'Order Completed',
  ORDER_SUBMITTED: 'Order Submitted'
};

export const quoteStatus = {
  incomplete: 'INCOMPLETE',
  pendingApproval: 'PENDING_APPROVAL',
  approved: 'QUOTE_APPROVED',
  waitingOnSales: 'WAITING_ON_SALES'
};

export const contentFulFields = {
  [prequalificationForm]: {
    existingInternetConnection:
      'doesTheCustomerHaveAnExistingInternetConnection',
    telusWorkplace: 'isThisOrderAPartOfTELUSWorkplace',
    fieldCustomerSegment: 'customerSegment',
    fieldVulcanOrder: 'vulcanOrder',
    fieldRecontractCustomer: 'recontractCustomer'
  },
  starterSeatDetails: 'starterSeatDetails',
  officeSeatDetails: 'officeSeatDetails'
};

export const starterSeatName = 'Starter Seat';
export const officeSeatName = 'Office Seat';

// Payload keys
export const keyDevices = 'devices';
export const keyWhiteGloveLocations = 'whiteGloveLocations';
export const keyDirectoryListingDetails = 'directoryListingDetails';
export const keyDirectoryListing = 'Directory Listing';
export const keyDirectoryListingType = 'directoryListing';
export const keyPrimaryDirectoryListingType = 'primaryDirectoryListingType';
export const keyTotalNoOfSeats = 'totalNoOfSeats';
export const keySpareDevices = 'additionalSpareDevices';
export const keyFeatures = 'features';
export const keyStarterSeatRateStandard = 'starterSeatRateStandard';
export const keyOfficeSeatRateStandard = 'officeSeatRateStandard';
export const keyGSuiteBusinessLicences = 'gSuiteBusinessLicences';
export const keyGSuiteEligible = 'gSuiteEligible';
export const keyGSuiteComplimentarySeats = 'gSuiteComplimentarySeats';
export const keyChannelId = 'channelId';
export const keyChannelName = 'channelName';
export const keyDevicesWereChanged = 'devicesWereChanged';
export const keyOutlet = 'outlet';
export const keyBusinessAppPlans = 'businessAppPlans';

// Form fields names
export const fieldEmailSigningAuthority = 'email_signingAuthority';
export const fieldProductNameBA = 'productNameBA';
export const fieldAddProductBA = 'addProductBA';
export const fieldStreetNumberAddress = 'streetNumber_address';
export const fieldOrderRequestTypeBA = 'orderRequestTypeBA';
export const fieldOtherServicesCustomerWillTakeBA =
  'otherServicesCustomerWillTakeBA';
export const fieldGoogleProductEditionsBA = 'googleProductEditionsBA';
export const fieldESChatProductEditionsBA = 'esChatProductEditionsBA';
export const fieldMicrosoftProductEditionsBA = 'microsoftProductEditionsBA';
export const fieldTermProductBA = 'termProductBA';
export const fieldProductInOrderFor = 'productInOrderFor';
export const fieldSameAsAdminContact = 'sameAsAdminContact';
export const fieldUploadCustomerReadinessChecklist =
  'uploadCustomerReadinessChecklist';
export const fieldEeEnterEmailSigningAuthority =
  'reEnterEmail_signingAuthority';
export const fieldProvinceOfTheOrder = 'provinceOfTheOrder';
export const fieldTypeOfInstallation = 'typeOfInstallation';
export const fieldBusinessConnectEdition = 'businessConnectEdition';
export const fieldCustomerAdvisoriesCurrentSpeedNotSupportUsers =
  'customerAdvisories_telusNoResponsibleIfCurrentSpeedNotSupportUsers';
export const fieldBusinessConnectEditionWorkplace =
  'businessConnectEditionWorkplace';
export const fieldDoesCustomerRequirePrimaryIpDeskPhones =
  'doesCustomerRequirePrimaryIpDeskPhones';
export const fieldDoesCustomerRequireSpareDevices =
  'doesCustomerRequireSpareDevices';
export const fieldAddDevices = 'addDevices';
export const fieldAddSpareDevices = 'addSpareDevices';
export const fieldStarterSeat = 'starterSeat';
export const c2fDeviceUps = 'c2fDeviceUps';
export const fieldTransferBusinessOwnership = 'TransferBusinessOwnership';
// export const c2fDeviceUps = 'c2fDeviceUps';
export const customerHasMsa = 'customerHasMsa';
export const c2fDevice24PortApa = 'c2fDevice24PortApa';
export const telusBusinessLimitedExtensions = 'telusBusinessLimitedExtensions';
export const fieldLongDistance = 'longDistance';
export const fieldOfficeSeats = 'officeSeats';
export const fieldDoYouWantToBundleThisBusinessConnectServiceWithWLS =
  'doYouWantToBundleThisBusinessConnectServiceWithWLS';
export const fieldDoesTheCustomerRequireWhiteGlove =
  'doesTheCustomerRequireWhiteGlove';
export const fieldNumberOfSitesThatRequireWhiteGlove =
  'numberOfSitesThatRequireWhiteGlove';
export const fieldNumberOfSeatsThatRequireWhiteGlove =
  'numberOfSeatsThatRequireWhiteGlove';
export const fieldNumberOfSeatsThatRequireWhiteGloveAI =
  'numberOfSeatsThatRequireWhiteGloveAI';
export const fieldHowCustomerWantToPayForWhiteGlove =
  'howCustomerWantToPayForWhiteGlove';
export const fieldTelusBusinessConnectRooms = 'telusBusinessConnectRooms';
export const fieldtelusBusinessConnectRoomConnector =
  'telusBusinessConnectRoomConnector';
export const fieldTelusBusinessConnectLiveReports =
  'telusBusinessConnectLiveReports';
export const fieldTelusBusinessConnectLargeMeetings200 =
  'telusBusinessConnectLargeMeetings200';
export const fieldTelusBusinessConnectRoomsNumberOfLicences =
  'telusBusinessConnectRooms_numberOfLicences';
export const fieldTelusBusinessConnectLiveReportsNumberOfLicences =
  'telusBusinessConnectLiveReports_numberOfLicences';
export const fieldTelusBusinessConnectRoomConnectorNumberOfLicences =
  'telusBusinessConnectRoomConnector_numberOfLicences';
export const fieldTelusBusinessConnectLargeMeetings200NumberOfLicences =
  'telusBusinessConnectLargeMeetings200_numberOfLicences';
export const fieldTelusBusinessConnectLargeMeetings300NumberOfLicences =
  'telusBusinessConnectLargeMeetings300_numberOfLicences';
export const fieldTelusBusinessConnectLargeMeetings500NumberOfLicences =
  'telusBusinessConnectLargeMeetings500_numberOfLicences';
export const fieldLiveReportsOdysseyAI = 'liveReportsOdysseyAI';
export const fieldLargeMeetingsOdysseyAI = 'largeMeetingsOdysseyAI';
export const fieldDoesTheCustomerRequireSmartHub =
  'doesTheCustomerRequireSmartHub';
export const fieldAdditionalTollFreeNumbersNumber =
  'additionalTollFreeNumbers_number';
export const fieldWhoIsTheExistingInternetProvider =
  'whoIsTheExistingInternetProvider';
export const fieldWhoIsTheExistingInternetProviderForOtherState =
  'whoIsTheExistingInternetProviderForOtherState';
export const fieldPromotionCode = 'promotionCode';
export const fieldPayment = 'payment';
export const fieldPlan = 'plan';
export const fieldNumberOfTollFreeMinutes = 'numberOfTollFreeMinutes';
export const fieldMPP = 'MPP';
export const fieldCustomerInformation = 'customerInfo';
export const fieldOfferConfiguration = 'offerConfiguration';
export const fieldIsOrderAvailableForPromotion =
  'isTheOrderAvailableForPromotion';
export const fieldVpbStarterSeatRate = 'vpbStarterSeatRate';
export const fieldVbpRequired = 'vbpRequired';
export const fieldEVSOfferCode = 'eVSOfferCode';
export const fieldBusinessType = 'businessType';
export const fielfirstNameprimaryContact = 'firstName_primaryContact';
export const fieldLastNamePrimaryContact = 'lastName_primaryContact';
export const fieldPhoneNumberPrimaryContact = 'phoneNumber_primaryContact';
export const fieldEmailPrimaryContact = 'email_primaryContact';
export const fieldRCIDOdyssey = 'RCIDOdyssey';
export const primarySalesContact = 'Primary Sales Contact';
export const existingBusinessConnectOdysseyBAN =
  'Existing Business Connect Odyssey BAN number';

export const fieldCustomerAdvisoriesAdditionalWiringAndLaborCharges =
  'customerAdvisories_additionalWiringAndLaborCharges';
export const fieldCustomerAdvisedBusinessConnectOrder =
  'customerAdvisedBusiness_ConnectOrder';
export const fieldLegalBusinessNameBusinessPersonal =
  'legalBusinessName_businessPersonal';
export const fieldLegalBusinessNameBusinessRegular =
  'legalBusinessName_businessRegular';
export const fieldOperatingAs = 'operatingAs';
export const fieldBusinessIncorporationNumber = 'businessIncorporationNumber';
export const fieldIncorporationDate = 'incorporationDate';
export const fieldDriversLicenseNumber = 'driversLicenseNumber';
export const fieldDriversLicenseExpiry = 'driversLicenseExpiry';
export const fieldDateOfBirth = 'dateOfBirth';
export const fieldInternetOffer = 'internetOffer';
export const fieldContractTerm = 'contractTerm';
export const contractTerm3Years = '3 years';
export const contractTerm5Years = '5 years';
export const fieldHaveYouArrangedWhiteGloveTechnician =
  'haveYouArrangedWhiteGloveTechnician';
export const fieldWillYourDealershipBePerformingThisWhiteGlove =
  'willYourDealershipBePerformingThisWhiteGlove';
export const fieldDealershipName = 'dealershipName';
export const fieldDealerFirstName = 'dealerFirstName';
export const fieldDealerLastName = 'dealerLastName';
export const fieldDealerPhoneNumber = 'dealerPhoneNumber';
export const fieldPhoneNumber = 'phoneNumber';
export const tollFree = 'Toll Free';
export const fieldTollFreePhoneNumber = 'tollFreePhoneNumber';
export const fieldPhoneNumbersBeportedOdyssey = 'phoneNumbersBeportedOdyssey';
export const fieldPhoneNumberOdyssey = 'phoneNumberOdyssey';
export const invalidPhoneNumber = 'invalid Phone Number';
export const fieldDealerEmail = 'dealerEmail';
export const fieldWillTheLocalPhoneNumberBePortedIn =
  'willTheLocalPhoneNumberBePortedIn';
export const fieldWillTheTollFreeBePortedIn = 'willTheTollFreeBeBortedIn';
export const fieldProvider = 'provider';
export const fieldPin = 'pin';
export const fieldPinBA = 'pinBA';
export const fieldMsaEContractBA = 'msaEContractBA';
export const fieldDiscountedPricing = 'discountedPricing';
export const fieldBusinessIncorporationNumberBA =
  'businessIncorporationNumberBA';
export const fieldBusinessIncorporativeDateBA = 'businessIncorporativeDateBA';
export const fieldNoteStarterSeat = 'noteStarterSeat';
export const fieldNoteOfficeSeat = 'noteOfficeSeat';
export const fieldNoteVoicePlusRecontract = 'voicePlusRecontractNote';
export const fieldNewPriceNote = 'newPriceNote';
export const fieldOptOutFromGSuiteBusinessLicenses =
  'optOutFromGSuiteBusinessLicenses';
export const fieldAdditionalGSuiteBusinessLicences =
  'additionalGSuiteBusinessLicences';
export const fieldGSuiteBasicLicences = 'gSuiteBasicLicences';
export const fieldGSuiteInstallAndSetup = 'gSuiteInstallAndSetup';
export const fieldDeviceType = 'deviceType';
export const fieldRateCenterProvince = 'rateCenterProvince';
export const fieldRateCenter = 'rateCenter';
export const fieldCustomerTollFreeLocalNumberOdyssey =
  'customerTollFreeLocalNumberOdyssey';
export const fieldGSuiteEmailMigrationServices = 'gSuiteEmailMigrationServices';
export const fieldGSuiteEmailMigrationServicesPaymentType =
  'gSuiteEmailMigrationServicesPaymentType';
export const fieldDoesTheCustomerHaveADomainAlready =
  'doesTheCustomerHaveADomainAlready';
export const fieldDomainToBeAssociatedWithGSuiteAccount =
  'domainToBeAssociatedWithGSuiteAccount';
export const fieldIsThisAnExistingGSuiteCustomer =
  'isThisAnExistingGSuiteCustomer';
export const fieldAdditionalTollFreeMinutePacks =
  'additionalTollFreeMinutePacks';
export const fieldAdditionalTollFreeMinutePacksForOdyssey =
  'additionalTollFreeMinutePacksOdyssey';
export const fieldAdditionalTollFreeNumbers = 'additionalTollFreeNumbers';
export const fieldExistingBusinessConnectBANNumber =
  'existingBusinessConnectBANNumber';
export const fieldExistingBusinessConnectBANNumberReconnect =
  'existingBusinessConnectBANNumber_recontract';
export const fieldKANA = 'KANA';
export const fieldKANACAR = 'KANA/CAR';
export const fieldBAN = 'BAN';
export const fieldVbpTerm = 'vbpTerm';
export const fieldContractStartDate = 'contractStartDate';

export const fieldIsThisOrderForAMobileOrVoiceEdition =
  'isThisOrderForAMobileOrVoiceEdition';
export const fieldOtherTelusServices = 'otherTelusServices';
export const fieldeContractNumber = 'eContractNumber';
export const fieldCustomerSegment = 'customerSegment';
export const fieldEExistingTelusServices = 'existingTelusServices';
export const fieldVulcanOrder = 'vulcanOrder';
export const fieldIsThisOrderAPartOfTELUSWorkplace =
  'isThisOrderAPartOfTELUSWorkplace';
export const fieldWhatIsTheCustomersCurrentPrice =
  'whatIsTheCustomersCurrentPrice';
export const fieldWhatIsTheCustomersCurrentStarterSeatPrice =
  'whatIsTheCustomersCurrentStarterSeatPrice';
export const fieldWhatIsTheCustomersCurrentOfficeSeatPrice =
  'whatIsTheCustomersCurrentOfficeSeatPrice';
export const fieldRateChangeApprovedBy = 'rateChangeApprovedBy';
export const fieldIsTheCustomerPriceChanging = 'isTheCustomerPriceChanging';
export const fieldWhatIsTheNewStarterSeatPrice = 'whatIsTheNewStarterSeatPrice';
export const fieldWhatIsTheNewOfficeSeatPrice = 'whatIsTheNewOfficeSeatPrice';
export const fieldAvailableDiscountsAndPromotions =
  'availableDiscountsAndPromotions';
export const fieldCouponBasedDiscountOdysseyAI = 'couponBasedDiscountOdysseyAI';
export const fieldProfessionalServicesFileCharges =
  'professionalServicesFileCharges';
export const fieldProfessionalServicesFileNote =
  'professionalServicesFileNote';
export const fieldProfessionalServicesFile = 'professionalServicesFile';
export const fieldMultisiteOrder = 'multisiteOrder';
export const fieldMultisiteOrderOdyssey = 'multisiteOrderForOdyssey';
export const fieldMinimumSeats = 'minimumSeats';
export const fieldMsftDirectRouting = 'msftDirectRouting';
export const fieldDirectoryListing = 'directoryListing';
export const fieldDoesTheCustomerHaveAnExistingInternetConnection =
  'doesTheCustomerHaveAnExistingInternetConnection';
export const fieldVpbOfficeSeatRate = 'vpbOfficeSeatRate';
export const fieldPhoneNumberAdministratorContact =
  'phoneNumber_administratorContact';
export const fieldNumberOfMultiSites = 'numberOfMultiSites';
export const fieldNumberOfMultiSitesOdyssey = 'numberOfMultiSitesForOdyssey';
export const fieldStreetNumberServiceAddress = 'streetNumber_serviceAddress';
export const fieldStreetNameServiceAddress = 'streetName_serviceAddress';
export const fieldStreetNameShippingAddress = 'streetName_shippingAddress';
export const fieldUnitNumberServiceAddress = 'unitNumber_serviceAddress';
export const fieldUnitTypeServiceAddress = 'unitType_serviceAddress';
export const fieldCityServiceAddress = 'city_serviceAddress';
export const fieldProvinceServiceAddress = 'province_serviceAddress';
export const fieldPostalCodeServiceAddress = 'postalCode_serviceAddress';
export const allowedProvinceQCBundle = [
  'Québec',
  'québec',
  'Quebec',
  'quebec',
  'QC',
  'qc'
];
export const fieldIsFibreOpticDrop = 'isFibreOpticDrop';
export const valueCityLondon = 'London';
/**
 * Cities in scope for 100% Pure Fibre Drop grouped by province.
 * Matching is case-insensitive and accent-insensitive (e.g. 'Québec' === 'quebec').
 * Keys and values MUST be in normalized form: lowercase + diacritics stripped.
 * The consumer normalizes inputs the same way before lookup.
 */
export const pureFibreDropEligibleCitiesByProvince = {
  ontario: ['london', 'kitchener', 'st. catharines', 'st catharines', 'saint catharines', 'cambridge'],
  quebec: ['laval']
};
export const valueProvinceOntario = 'Ontario';
export const fieldCcContractTerm = 'ccContractTerm';
export const fieldRsi = 'rsi';
export const fieldRsiLicenses = 'rsiLicenses';
export const fieldAdditionalRsiOptions = 'additionalRsiOptions';
export const fieldGenesis = 'genesis';
export const fieldGenesisLicenses = 'genesisLicenses';
export const keyAdditionalRsiOptions = 'Additional RSI options';
export const fieldYesToAllAdvisories = 'yesToAllAdvisories';
export const fieldRouterPaymentOption = 'routerPaymentOption';
export const fieldCoperToFibreMigration = 'coperToFibreMigration';
export const fieldCustomerRequireAIFeatures = 'customerRequireAIFeatures';
export const fieldMigrationGoco = 'migrationGoco';
export const field5UnlimitedLongDistanceCanUs = '5UnlimitedLongDistanceCanUs';
export const field10UnlimitedLongDistanceCanUs = '10UnlimitedLongDistanceCanUs';
export const fieldc2fMigrationSeatPrices = 'c2fMigrationSeatPrices';
export const fieldCurrentCopperRateOdyssey = 'currentCopperRateOdyssey';
export const fieldNewCustomerPriceOdyssey = 'newCustomerPriceOdyssey';
export const fieldBusinessConnectImplementationTollFreeNumber =
  'businessConnectImplementationTollFreeNumber';
export const fieldAccountNumberBANBA = 'accountNumberBAN_BA';
export const fieldCustomerInvoiceForBA = 'customerInvoiceForBA';
export const fieldBusinessAppBillingNoteBA = 'businessAppBillingNoteBA';
export const fieldBillingPhoneNumber = 'billingPhoneNumber';
export const fieldAttachmentsBA = 'attachmentsBA';
export const fieldExistingCustomerBA = 'existingCustomerBA';
export const fieldExistingCustomerDomain = 'existingCustomerDomain';
export const fieldExistingBusinessConnectOrWirelessAccountBA =
  'existingBusinessConnectOrWirelessAccountBA';
// Form field groups
export const groupVbpOptions = 'groupVbpOptions';
export const groupDirectoryListing = 'groupDirectoryListing';
export const groupBusinessConnectImplementation =
  'groupBusinessConnectImplementation';
export const fieldC2fAutomatedActivation = 'c2fAutomatedActivation';
export const fieldOfficeSeatFirstName = 'officeSeatFirstName';
export const fieldOfficeSeatLastName = 'officeSeatLastName';
export const fieldOfficeSeatEmail = 'officeSeatEmail';
export const fieldSubmittingOnBehalfOf = 'submittingOnBehalfOf';
export const fieldIsSrtTeamMember = 'isSrtTeamMember';
export const fieldPreferredInstallationDate = 'preferredInstallationDate';
export const fieldPreferredInstallDate = 'preferredInstallDate';
export const fieldPreferredInstallDate1 = 'preferredInstallDate1';
export const fieldPreferredInstallDate2 = 'preferredInstallDate2';
export const fieldPreferredInstallDate3 = 'preferredInstallDate3';
export const fieldPreferredTimePeriod = 'preferredTimePeriod';
export const fieldNumberOfLicencesOdyssey = 'numberOfLicencesOdyssey';
export const fieldIotAccountType = 'iotAccountType';
export const fieldIotCorporateType = 'iotCorporateType';
export const fieldIotNewOrExisting = 'iotNewOrExisting';
export const fieldIotAccessAccountViaSmartDesktop =
  'iotAccessAccountViaSmartDesktop';
export const fieldIotTelusAccountNumber = 'iotTelusAccountNumber';
export const fieldIotCaratCaseId = 'iotCaratCaseId';
export const fieldIotCreditCheckPassInCarat = 'iotCreditCheckPassInCarat';
export const fieldIotAddonSpecificSubscriber = 'iotAddonSpecificSubscriber';
export const fieldIotAddonSubscriberList = 'iotAddonSubscriberList';
export const fieldIotVehicleOptions = 'iotVehicleOptions';
export const fieldIotAdditionalAttachements = 'iotAdditionalAttachements';
export const fieldIotAdditionalComment = 'iotAdditionalComment';
export const fieldIotActivationOrRenwal = 'iotActivationOrRenwal';
export const fieldIotProductSelected = 'iotProductSelected';
export const fieldCaratCreditCheckFailMessage = 'caratCreditCheckFailMessage';
export const fieldIotIncorporationNumber = 'iotIncorporationNumber';
export const fieldIotIncorporationDate = 'iotIncorporationDate';
export const fieldIotSubscribersRenewalOptions = 'iotSubscribersRenewalOptions';
export const fieldIotCreditCheckPassInMss = 'iotCreditCheckPassInMss';
export const fieldIotManagersEmailApproval = 'iotManagersEmailApproval';
export const iotGeotabFleetTrackerOEM = 'Geotab Fleet Tracker OEM';
export const fieldIotDeliveryOptions = 'iotDeliveryOptions';
export const fieldAdditionalLocalNumber = 'additionalLocalNumber';
export const fieldAdditionalTollFreeNumber = 'additionalTollFreeNumber';
export const fieldIotCustomerRequireProInstallService =
  'iotCustomerRequireProInstallService';
export const fieldIotPromoAvailable = 'iotPromoAvailable';
export const fieldGroupNonC2FFlow = 'nonC2FFlow';
export const fieldUploadSpeed = 'uploadSpeed';
export const fieldUploadSpeedOdyssey = 'uploadSpeedForOdyssey';
export const fieldUploadSpeedForShawOther = 'uploadSpeedForShawOther';
export const fieldUploadSpeedForShawOtherOdyssey =
  'uploadSpeedForShawOtherForOdyssey';
export const fieldUploadSpeedForCopperWire = 'uploadSpeedForCopperWire';
export const fieldUploadSpeedForCopperWireOdyssey =
  'uploadSpeedForCopperWireForOdyssey';
export const fieldUploadSpeedForShawOtherAlbertaAndBritishColumbia =
  'uploadSpeedForShawOtherAlbertaAndBritishColumbia';
export const fieldUploadSpeedForShawOtherAlbertaAndBritishColumbiaOdyssey =
  'uploadSpeedForShawOtherAlbertaAndBritishColumbiaForOdyssey';
export const fieldCustomerMigrating = 'CustomerMigrating';
export const fieldMobilityAccountNote = 'mobilityAccountNote';
export const fieldRecontractCustomer = 'recontractCustomer';
export const fieldRecontractChangeEdition = 'recontractChangeEdition';
export const fieldRecontractAddSubtractSeats = 'recontractAddSubtractSeats';
export const fieldDoesCustomerRequireRouter = 'doesCustomerRequireRouter';
export const fieldRecontractSeatsCustomerAdding =
  'recontractSeatsCustomerAdding';
export const filedCurrentAddressInSmartDesktop = 'currentAddressInSmartDesktop';
export const approvalCodeDealerInstall = 'Dealer Install';
export const fieldCustomerInfo = 'customerInfo';
export const fieldBillingAddress = 'billingAddress';
export const fieldServiceAddress = 'serviceAddress';
export const approvalCodeProfessionalInstall =
  'Professional Install for 1-10 Seats';

export const filedCoOrderLocation = 'coOrderLocation';
export const fieldIsThisAnEContractCustomer = 'isThisAnEContractCustomer';
export const fieldWLSBusinessConnect = 'wlsBusinessConnect';
export const filedNeedMoreThanSingleServiceAddress =
  'needMoreThanSingleServiceAddress';
export const filedNeedMoreThan5Lines = 'needMoreThan5Lines';
export const filedNeedMediaAdvertisingBilling = 'needMediaAdvertisingBilling';
export const filedNeedBilledDirectoryListing = 'needBilledDirectoryListing';
export const filedIsTheirAnyReasonToGoThroughMySOF =
  'isTheirAnyReasonToGoThroughMySOF';
export const filedReasonForMySOFOrder = 'reasonForMySOFOrder';
export const fieldIotFillipFleetIdCheck = 'iotFillipFleetIdCheck';
export const fieldVbpNumberFreePromotions = 'vbpNumberFreePromotions';
export const fieldVbpApprovedCustomOffer = 'vbpApprovedCustomOffer';
export const fieldVbpApprovalEmailAttachment = 'vbpApprovalEmailAttachment';
export const fieldVbpNumberFreePromotionsCommercial =
  'vbpNumberFreePromotionsCommercial';

// Form fields prices
export const priceSeatsWhiteGloveEasyPayment = 6;
export const priceSeatsWhiteGloveUpfront = 140;
export const priceSitesWhiteGloveFee = 140;
export const approvalCodePriceSeatsWhiteGloveEasyPayment = 10;
export const approvalCodePriceSeatsWhiteGloveUpfront = 240;

// Section names
export const sectionAdditionalFeatures = 'additionalFeatures';
export const sectionSalesRepInfo = 'salesRepInfo';
export const sectionSalesRepInfoSRT = 'salesRepInfoSRT';
export const sectionDeviceDetails = 'deviceDetails';
export const sectionGSuiteDetails = 'gSuiteDetails';
export const sectionWhiteGloveDetails = 'whiteGloveDetails';
export const sectionNetworkPrequalification = 'networkPrequalification';
export const sectionOrderDetails = 'orderDetails';

// Payment types
export const paymentTypeUpfront = '1';
export const paymentTypeEasyPayment = '2';

// Order Type
export const orderTypeNew = 'New';
export const orderTypeNewFrench = 'Nouveau';

export const vpbRateOtherEnglish = 'Other';
export const vpbRateOtherFrench = 'Autre';

export const keyModifyQuote = 'MODIFY_QUOTE';
export const keyProceedWithOrder = 'PROCEED_WITH_ORDER';
export const keyViewOrder = 'VIEW_ORDER';
export const keyDeleteOrder = 'DELETE_ORDER';
export const keySaveQuotePdf = 'SAVE_QUOTE_PDF';
export const keyContractResend = 'CONTRACT_RESEND';
export const keyOrderReturn = 'ORDER_RETURN';

export const uploadCustomerReadinessChecklist =
  'uploadCustomerReadinessChecklist';
export const uploadCustomerReadinessChecklistTypeId = 1;
export const uploadCustomerAdvisoriesTypeId = 0;

export const multisiteUniqueFields = [
  'id',
  'orderId',
  'createdAt',
  'updatedAt',
  'streetNumber_serviceAddress',
  'streetName_serviceAddress',
  'unitNumber_serviceAddress',
  'unitType_serviceAddress',
  'city_serviceAddress',
  'province_serviceAddress',
  'postalCode_serviceAddress',
  'sameAsSigningAuthority',
  'sameAsAdmin',
  'starterSeat',
  'officeSeats',
  'doesTheCustomerRequireSmartHub',
  'doesCustomerRequirePrimaryIpDeskPhones',
  'devices',
  'doesCustomerRequireSpareDevices',
  'additionalSpareDevices',
  'doesTheCustomerRequireWhiteGlove',
  'numberOfSeatsThatRequireWhiteGlove',
  'numberOfSeatsThatRequireWhiteGloveAI',
  'howCustomerWantToPayForWhiteGlove',
  'features',
  'telusBusinessConnectRooms',
  'telusBusinessConnectRooms_numberOfLicences',
  'telusBusinessConnectLiveReports',
  'telusBusinessConnectLiveReports_numberOfLicences',
  'telusBusinessConnectRoomConnector',
  'telusBusinessConnectRoomConnector_numberOfLicences',
  'telusBusinessConnectLargeMeetings200',
  'telusBusinessConnectLargeMeetings200_numberOfLicences',
  'telusBusinessConnectLargeMeetings300',
  'telusBusinessConnectLargeMeetings300_numberOfLicences',
  'telusBusinessConnectLargeMeetings500',
  'telusBusinessConnectLargeMeetings500_numberOfLicences',
  'additionalTollFreeMinutePacks',
  'numberOfTollFreeMinutes',
  'staticIp',
  'additionalTollFreeNumbers',
  'msftDirectRouting',
  'directoryListing',
  'optOutFromGSuiteBusinessLicenses',
  'additionalGSuiteBusinessLicences',
  'gSuiteInstallAndSetup',
  'gSuiteEmailMigrationServices',
  'gSuiteEmailMigrationServices',
  'gSuiteEmailMigrationServicesPaymentType',
  'whichDirectoryShouldTheNumberBeListedin',
  'otherDirectoryListing',
  'directoryListingDetails',
  'availableDiscountsAndPromotions',
  'managedInternetProductsSold',
  'customerNeedCanadaDataLocalization',
  'customerRequireActiveDirectoryIntegration',
  'clientRequireBulkDeviceUpdate',
  'customerPortingNumbersFromPRICentrexSystem',
  'customerImplementingMultiLevelIVR',
  'customerUsingFaxline',
  'doesCustomerHaveATADevice',
  'customerNeedOverHeadPaging',
  'willCustomerRequireInsideWiring',
  'doesCustomerHaveCat5',
  'howManyLocationHaveCat5',
  'doesTheCustomerHaveADomainAlready',
  'domainToBeAssociatedWithGSuiteAccount',
  'firstName_administratorContact',
  'lastName_administratorContact',
  'phoneNumber_administratorContact',
  'email_administratorContact',
  'firstName_onsiteContact',
  'lastName_onsiteContact',
  'phoneNumber_onsiteContact',
  'email_onsiteContact'
];

export const mppOffersOutletIds = [
'1100054212',
'1100054213',
'1100054211',
'1100054214',
'1100054215',
'1100054216',
'1100052612',
'1100052634',
'1100052622',
'1100052609',
'1100052610',
'1100052628',
'1100052618',
'1100052630',
'1100052633',
'1100052600',
'1100049353',
'1100054217',
'1100054218',
'1100054405',
'1100055293',
'1100055292',
'1100055358',
'1100055359',
'1100056370',
'1100056369',
'1100056368',
'1100056367',
'1100056366',
'1100056365',
'1100056364',
'1100056363',
'1100056362',
'1100056361',
'1100056360',
'1100056359',
'1100056358',
'1100056357',
'1100056356',
'1100056355',
'1100056354',
'1100056353',
'1100056386',
'1100056375',
'1100056374',
'1100056373',
'1100056372',
'1100056371',
'1100056289',
'1100056288',
'1100056333',
'1100056265',
'1100056266',
'1100055822',
'1100056290',
'1100056332',
'1100055383',
'1100057125',
'1100057468',
'1100056292',
'1100056385',
];

export const closingToolOutletIds = [
  '1100052621',
  '1100052970',
  '1100052617',
  '1100052628',
  '1100052623',
  '1100052629',
  '1100052616',
  '1100052626',
  '1100052619',
  '1100052600',
  '1100052624',
  '1100052605',
  '1100053219',
  '1100052620',
  '1100052622',
  '1100052618',
  '1100052627',
  '1100052625'
];

export const $100OutletIds = [
  '1100054212',
  '1100054213',
  '1100056371',
  '1100056372',
  '1100056373',
  '1100056374',
  '1100056288',
  '1100056291'
];

export const readinessChecklistExemptOutletIds = [
  '1100056509',
  '1100056510'
];

export const smbIndirectSalesChannels = {
  'SMB Indirect Sales - Other': ['1100052561'],
  'SMB Indirect Sales - TAG': ['1100052562'],
  'SMB Indirect Sales - Elite Promotions': ['1100052563'],
  'SMB Indirect Sales- CORPO SOLUTION': ['1100052725'],
  'SMB Indirect Sales- CBTELECOM': ['1100052726'],
  'SMB Indirect Sales- IDS': ['1100052727'],
  'SMB Indirect Sales- MSG CONSULTING': ['1100052728'],
  'SMB Indirect Sales- CONNEXION FK': ['1100052729'],
  'SMB Indirect Sales- REVOLVE': ['1100052730'],
  'SMB Indirect Sales- GET INSTINCTIVE': ['1100052731'],
  'SMB Indirect Sales- TOPS TECH': ['1100052732'],
  'SMB Indirect Sales- OUTPUT': ['1100052733'],
  'SMB Indirect Sales- ATMOS MANAGEMENT': ['1100052734'],
  'SMB Indirect Sales- KOLLABB': ['1100052735'],
  'SMB Indirect Sales- UP SYSTEMS': ['1100052736'],
  'SMB Indirect Sales- WATCHDOG': ['1100052737']
};

export const channelOutletMapping = {
  'SMB A 1 to 30 1A': ['1100052600'],
  'SMB Growth Sales W 2B': ['1100052601'],
  'SMB Retention 1 to 30 1C': ['1100052602'],
  'SMB Retention 1 to 30 1D': ['1100052603'],
  'SMB Retention 30 to 100 2A': ['1100052604'],
  'SMB A 1 to 30 1C': ['1100052605'],
  'SMB Retention Sales 30 to 100 2D': ['1100052606'],
  'SMB Retention 30 to 100 2D': ['1100052607'],
  'SMB Growth Sales W 1A': ['1100052608'],
  'SMB Growth Sales W 1B': ['1100052609'],
  'SMB Growth Sales W 1C': ['1100052610'],
  'SMB Growth Sales W 1D': ['1100052611'],
  'SMB Growth Sales W 2A': ['1100052612'],
  'SMB Growth Sales W 2C': ['1100052614'],
  'SMB Growth Sales W 2D': ['1100052615'],
  'SMB Growth Sales E 1A': ['1100052616'],
  'SMB Growth Sales E 2B': ['1100052617'],
  'SMB Growth Sales E 3C': ['1100052618'],
  'SMB Growth Sales E 1D': ['1100052619'],
  'SMB Growth Sales E 3E': ['1100052620'],
  'SMB Growth Sales E 2A': ['1100052621'],
  'SMB Growth Sales E 3A': ['1100052622'],
  'SMB Growth Sales E 2C': ['1100052623'],
  'SMB A 1 to 30 1B': ['1100052624'],
  'SMB Growth Sales E 3D': ['1100052625'],
  'SMB Growth Sales E 1B': ['1100052626'],
  'SMB Growth Sales E 3B': ['1100052627'],
  'SMB Growth Sales E 2D': ['1100052628'],
  'SMB Growth Sales E 1C': ['1100052629'],
  'SMB Growth Sales E 4A': ['1100052630'],
  'SMB Growth Sales E 4B': ['1100052631'],
  'SMB Growth Sales E 4C': ['1100052632'],
  'SMB Growth Sales E 4D': ['1100053088'],
  'SMB Growth Sales E 4E': ['1100052634'],
  'SMB Growth Sales 30 to 100 1A': ['1100052635'],
  'SMB Growth Sales 30 to 100 1B': ['1100052636'],
  'SMB Growth Sales 30 to 100 1D': ['1100052638'],
  'SMB Growth Sales 30 to 100 2A': ['1100052639'],
  'SMB Growth Sales 30 to 100 1C': ['1100052640'],
  'SMB Growth Sales 30 to 100 2C': ['1100052641'],
  'SMB L&R 1': ['1100052642'],
  'SMB L&R 2': ['1100052643'],
  'SMB L&R 3': ['1100052644'],
  'SMB L&R 4': ['1100052645'],
  'SMB L&R 5': ['1100052646'],
  'SMB L&R TI': ['1100052647'],
  'SMB Indirect Sales - Other': ['1100052561'],
  'SMB Indirect Sales - TAG': ['1100052562'],
  'SMB Indirect Sales - Elite Promotions': ['1100052563'],
  'SMB New Growth Market 1': ['1100050829'],
  'SMB New Growth Market 2': ['1100052073'],
  'SMB Indirect Sales- CORPO SOLUTION': ['1100052725'],
  'SMB Indirect Sales- CBTELECOM': ['1100052726'],
  'SMB Indirect Sales- IDS': ['1100052727'],
  'SMB Indirect Sales- MSG CONSULTING': ['1100052728'],
  'SMB Indirect Sales- CONNEXION FK': ['1100052729'],
  'SMB Indirect Sales- REVOLVE': ['1100052730'],
  'SMB Indirect Sales- GET INSTINCTIVE': ['1100052731'],
  'SMB Indirect Sales- TOPS TECH': ['1100052732'],
  'SMB Indirect Sales- OUTPUT': ['1100052733'],
  'SMB Indirect Sales- ATMOS MANAGEMENT': ['1100052734'],
  'SMB Indirect Sales- KOLLABB': ['1100052735'],
  'SMB Indirect Sales- UP SYSTEMS': ['1100052736'],
  'SMB Indirect Sales- WATCHDOG': ['1100052737'],
  'SMB Growth Sales 30 to 100 3B': ['1100052968'],
  'SMB Growth Sales Advance QC': ['1100052976'],
  'SMB Growth Sales Advance ON': ['1100053184'],
  'TAG BC': ['1100053076'],
  'TAG AB': ['1100053077'],
  'Elite Promotions & Marketing Inc.': ['1100053078'],
  'EVOLUTION CLOUD INC': ['1100053079'],
  '7X': ['1100053080'],
  'Tech23 Solutions Inc.': ['1100053081'],
  'Output Inc.': ['1100053082'],
  'SMB New Growth Market 3': ['1100052952'],
  'SMB New Growth Market 4': ['1100053235'],
  'SMB Growth Sales 30 to 100 3A': ['1100053244'],
  'SMB Growth Sales 30 to 100 3C': ['1100052637'],
  'SMB Growth Sales E 2E': ['1100052970'],
  'SMB Growth Sales Advance BDR': ['9900000019'],
  'SMB Growth Sales 30 to 100 2B': ['1100054078'],
  'SMB Growth Sales Advance WEST': ['1100054079'],
  'SMB Growth Sales Fully Managed': ['1100054080'],
  'SMB A 1 to 30 1E': ['1100053219'],
  'White Glove NBD Technicians': ['1000013457'],
  'SMB L&R TI 2': ['1100052977'],
  'SMB L&R TI 3': ['1100053942'],
  'SMB TI Sales Digital': ['1100049353'],
  'SMB TI Sales Base Management': ['1100050925'],
  'SMB TI ADT Retention': ['1100054211'],
  'SMB TI Digital - EN': ['1100054212'],
  'SMB TI Digital - FR': ['1100054213'],
  'SMB TI HSIA Growth': ['1100054214'],
  'SMB TI NBS Value Add': ['1100054215'],
  'SMB TI WLN Retention': ['1100054216'],
  'SMB TI WLS Growth QC': ['1100054217'],
  'SMB TI WLS Growth ROC': ['1100054218'],
  'SMB Growth Sales E 3F': ['1100055348'],
  'SBS Telesales TI': ['Not Provided'], // for this channel outlet id is not provided
  PiiComm: ['9900000020'],
  'SMB RFS 1': ['1100054964'],
  'SMB RFS 2': ['1100054965'],
  'SMB TI Growth National': ['1100054405'],
  'SMB Growth Sales Fully Managed B': ['1100054505'],
  AllianceIT: ['9900000021'],
  'SMB Retention Sales WEST': ['1100054407'],
  'SMB Growth Sales W 1E': ['1100055383'],
  'SMB Growth Sales 30 to 100 3D': ['1100054406'],
  'SMB TDE Growth West': ['1100055293'],
  'SMB TDE Growth East': ['1100055292'],
  'SMB TDE Nesting India': ['1100055358'],
  'SMB TDE Nesting Morocco': ['1100055359'],
  'SMB Growth Sales W 2E': ['1100055388'],
  'SMB Penny Sales West': ['1100055557'],
  'SMB TDE 30+ Retention': ['1100055822'],
  'SMB TDE Digital - Morocco 1': ['1100056288'],
  'SMB TDE QC G&R Morocco': ['1100056289'],
  'SMB TDE Penny': ['1100056265'],
  'SMB TDE High Churn': ['1100056266'],
  'SMB TDE ROC G&R India': ['1100056290'],
  'SMB TDE Digital - Morocco 2': ['1100056291'],
  'SMB TDE Digital EN - Manila 2': ['1100056292'],
  'SMB TDE Digital FR - Manila 2': ['1100056293'],
  'SMB TDE Digital Manila 2': ['1100056371'],
  'SMB TDE Digital Manila 3': ['1100056372'],
  'SMB TDE Digital Manila 4': ['1100056373'],
  'SMB TDE Digital Manila 5': ['1100056374'],
  'SMB TDE West G&R Manila 2': ['1100056375'],
  'SMB TDE West G&R Manila 3': ['1100056376'],
  'SMB TDE West G&R Manila 4': ['1100056377'],
  'SMB TDE West G&R Manila 5': ['1100056378'],
  'SMB TDE Penny Manila 2': ['1100056379'],
  'SMB TDE Penny Manila 3': ['1100056380'],
  'SMB TDE WLN Retention Manila 2': ['1100056381'],
  'SMB TDE WLN Retention Manila 3': ['1100056382'],
  'SMB TDE WLN Retention Manila 4': ['1100056383'],
  'SMB TDE WLN Retention Manila 5': ['1100056384'],
  'SMB TDE WLN Retention Manila 6': ['1100056385'],
  'SMB TDE 30+ Retention Manila 2': ['1100056386'],
  'SMB TDE ROC G&R Manila 2': ['1100056353'],
  'SMB TDE ROC G&R Manila 3': ['1100056354'],
  'SMB TDE ROC G&R Manila 4': ['1100056355'],
  'SMB TDE ROC G&R Manila 5': ['1100056356'],
  'SMB TDE ROC G&R Manila 6': ['1100056357'],
  'SMB TDE ROC G&R Manila 7': ['1100056358'],
  'SMB TDE ROC G&R Morocco 2': ['1100056359'],
  'SMB TDE ROC G&R Morocco 3': ['1100056360'],
  'SMB TDE QC G&R Morocco 2': ['1100056361'],
  'SMB TDE ROC G&R India 2': ['1100056362'],
  'SMB TDE ROC G&R India 3': ['1100056363'],
  'SMB TDE Growth India 1_2': ['1100056364'],
  'SMB TDE Growth India 1_3': ['1100056365'],
  'SMB TDE Growth India 1_4': ['1100056366'],
  'SMB TDE Growth India 2_2': ['1100056367'],
  'SMB TDE Growth India 2_3': ['1100056368'],
  'SMB TDE Growth India 2_4': ['1100056369'],
  'SMB TDE Growth India 3_2': ['1100056370'],
  'SMB TDE Growth India 1_5': ['1100057468'],
  'CBS - Field Technician': ['1100056407'],
  'CBS - Partner': ['1100056408'],
  'NBD - Field Technician': ['1100056409'],
  'NBD - Partner': ['1100056410'],
  'CSD - Field Technician': ['1100056411'],
  'CSD - Partner': ['1100056412'],
  'Field Sales Support': ['1100056397']
};

export const sof1HomeUrl = 'https://www.mysofportal.com';
export const sof2HomeUrl = 'https://www.mysalesorders.com';
export const adtHomeUrl = 'https://www.myorderdashboard.com';

export const allowedEmailsForVulcanFlow = [
  'nathan@smartcell.ca',
  'adam@smartcell.ca',
  'georgep@wireless-systems.net',
  'dimitram@wireless-systems.net',
  'zaid.khandwani@greenmobile.com',
  'archith.satheesh@greenmobile.com',
  'nmaldonado@communicationzone.ca',
  'lsanchez@communicationzone.ca',
  'kristen@mastercom.ca',
  'samer@mastercom.ca',
  'melvin.bailey@telus.com',
  'jeeno.wilson@telus.com',
  'waqas.arshad@telus.com',
  'diana.wu@telus.com',
  'amos.chen@telus.com',
  'samuel.zhang@telus.com',
  'deepesh.rathi@telus.com',
  'vijay.sridharan@telus.com',
  'jainil.parikh@telus.com',
  'sumit.sewag@telus.com',
  'lisa.hearty@telus.com',
  'hugo.madureira@telus.com',
  'harkeeratsingh.taneja@telus.com',
  'kartik.gupta@telus.com',
  'roopa.udeshi@telus.com',
  'ashley.hamlyn@telus.com',
  'lucy.nguyen@telus.com',
  'ruchika.vaid@telus.com',
  'arthur.macwan@telus.com',
  'hetal.shah@telus.com',
  'omer.nazir@telus.com',
  'nima.modir@telus.com',
  'sherwin.paniza@telus.com',
  'taran.gill@telus.com',
  'rahul.dalal@telus.com',
  'karan.meraiya@telus.com',
  'harman.dhaliwal@telus.com',
  'jawad.khan@telus.com',
  'jagdeep.singh1@telus.com',
  'somansh.gandhi@telus.com',
  'addy.pandey@telus.com',
  'jane.dumalag@telus.com',
  'ard.betita@telus.com',
  'homer.refran@telus.com',
  'analiza.lomabao2@telus.com',
  'joanne.valdez@telus.com',
  'mark_kristofferson.soho@telus.com',
  'rhea.abonita2@telus.com',
  'richard.joves@telus.com',
  'shoji.montemayor2@telus.com',
  'davidsyrill.roquero@telus.com',
  'louie.sabulao@telus.com',
  'romualdojr.simbulan@telus.com',
  'vidi.almodal@telus.com',
  'jennie-vy.tamo@telus.com',
  'nicell.lepiten@telus.com',
  'manoletsoleil.paguntalan@telus.com',
  'rachellearne.ignacio@telus.com',
  'provymae.abuyme@telus.com',
  'angela.famero@telus.com',
  'roderico.defelipe@telus.com',
  'ronmarc.cruz@telus.com',
  'maria_rowena.peril@telus.com',
  'annakatrina.kabigting@telus.com',
  'shoubo.ali@telus.com',
  'muhammad.tauqeer+admin@mobilelive.ca',
  'muhammad.tauqeer+sales@mobilelive.ca',
  'shoubo.ali6@telus.com',
  'dan.boyes@telus.com',
  'robert.brickell@telus.com',
  'harleen.gill@telus.com',
  'joery.voltaire@telus.com',
  'jesse.feliciano@telus.com',
  'maximino.sosagranados@telus.com',
  'erin.coulson@telus.com',
  'Mario.AbdouSaid@telus.com',
  'Cristian.FuentesFuentes@telus.com',
  'tsvetelin.zlatev@telus.com',
  'elida.bonillaalvarado@telus.com',
  'lap.tran@telus.com',
  'Nancy.Salazar_Villatoro@telus.com',
  'Ivan.AragonSolis@telus.com',
  'mazen@mastercom.ca',
  'sayayi@communicationzone.ca',
  'kstorr@communicationzone.ca',
  'jdowney@communicationzone.ca',
  'pantwi@communicationzone.ca',
  'tsze@communicationzone.ca',
  'nkemp@communicationzone.ca',
  'mike@smartcell.ca',
  'greg.gosselin@smartcell.ca',
  'doug@smartcell.ca',
  'corradog@wireless-systems.net',
  'anthonyg@wireless-systems.net',
  'lindsay.wright@telus.com',
  'kevin.wiley@telus.com',
  'carol.pais@telus.com',
  'rex.fu@telus.com'
];

export const allowedChannelsForFourMonthsFreePromo = [
  'SMB New Growth Market 1',
  'SMB New Growth Market 2',
  'NGM',
  'SMB Growth Sales W 1A',
  'SMB Growth Sales W 1B',
  'SMB Growth Sales W 1C',
  'SMB Growth Sales W 1D',
  'SMB Growth Sales W 2A',
  'SMB Growth Sales W 2B',
  'SMB Growth Sales W 2C',
  'SMB Growth Sales W 2D',
  'SMB Growth Sales E 1A',
  'SMB Growth Sales E 1B',
  'SMB Growth Sales E 1C',
  'SMB Growth Sales E 1D',
  'SMB Growth Sales E 1E',
  'SMB Growth Sales E 2A',
  'SMB Growth Sales E 2B',
  'SMB Growth Sales E 2C',
  'SMB Growth Sales E 2D',
  'SMB Growth Sales E 2E',
  'SMB Growth Sales E 3A',
  'SMB Growth Sales E 3B',
  'SMB Growth Sales E 3C',
  'SMB Growth Sales E 3D',
  'SMB Growth Sales E 4A',
  'SMB Growth Sales E 4B',
  'SMB Growth Sales E 4C',
  'SMB Growth Sales E 4D',
  'SMB Growth Sales E 4E',
  'SMB Growth Sales 30 to 100 1A',
  'SMB Growth Sales 30 to 100 1B',
  'SMB Growth Sales 30 to 100 1C',
  'SMB Growth Sales 30 to 100 1D',
  'SMB Growth Sales 30 to 100 2A',
  'SMB Growth Sales 30 to 100 2B',
  'SMB Growth Sales 30 to 100 2C',
  'SMB Growth Sales Advance 1',
  'SMB Growth Sales Advance 2',
  'SMB Retention 1 to 30 1A',
  'SMB Retention 1 to 30 1B',
  'SMB Retention 1 to 30 1C',
  'SMB Retention 1 to 30 1D',
  'SBS_TI_SALES',
  'SBS_TELESALES_TI',
  'SMB L&R TI',
  'TELUS SMB TI',
  'DEALER'
];

export const INITIAL_REGISTRATION_FIELD_VALUES = {
  role: '',
  firstName: '',
  lastName: '',
  email: '',
  password: '',
  channel: '',
  multiChannels: '',
  outlet: '',
  salesManager: '',
  salesManagerEmail: '',
  cpmsId: '',
  contactNumber: '',
  province: '',
  multiProvinces: [],
  recaptcha: '',
  channelOrgCode: '',
  dealership: '',
  xid: '',
  storeCode: '',
  requiresOrderAccess: ''
};

export const couponTypeEdition = 'edition';
export const couponTypeInstallation = 'installation';
export const couponTypeBillCredit = 'bill credit';

export const BillCreditPromo$70 = '$70 Bill Credit';
export const BillCreditPromo$75 = '$75 Bill Credit';
export const BillCreditPromo$140 = '$140 Bill Credit';
export const Online$100BillCredit = 'Online $100 bill credit';
export const EnhancedPromoSeat$26 = 'Enhanced Bundled $26 (1-14 seats)';
export const EnhancedPromoSeat$24 = 'Enhanced Bundled $24 (15-24 seats)';
export const EnhancedPromoSeat$22 = 'Enhanced Bundled $22 (25-49 seats)';
export const EnhancedPromoSeat$20 = 'Enhanced Bundled $20 (50-99 seats)';
export const EnhancedPromoSeat$19 = 'Enhanced Bundled $19 (100+ seats)';
export const EnhancedPromo$26 = 'Enhanced Bundled $26';
export const EnhancedPromo$24 = 'Enhanced Bundled $24';
export const EnhancedPromo$22 = 'Enhanced Bundled $22';
export const EnhancedPromo$20 = 'Enhanced Bundled $20';
export const EnhancedPromo$19 = 'Enhanced Bundled $19';
export const CompleteBundledSeat$36 = 'Complete Bundled $36 (1-14 Seats)';
export const CompleteBundleddSeat$34 = 'Complete Bundled $34 (15-24 Seats)';
export const CompleteBundleddSeat$32 = 'Complete Bundled $32 (25-49 seats)';
export const CompleteBundleddSeat$30 = 'Complete Bundled $30 (50-99 Seats)';
export const CompleteBundleddSeat$29 = 'Complete Bundled $29 (100+ Seats)';
export const CompleteBundled$36 = 'Complete Bundled $36';
export const CompleteBundled$34 = 'Complete Bundled $34';
export const CompleteBundled$32 = 'Complete Bundled $32';
export const CompleteBundled$29 = 'Complete Bundled $29';
// New BCON Bundled flat-rate offers (no seat tier).
// $25 for Regular BCON (all provinces);
// $10-off promos for BCON AI flow (3yr / 5yr term).
export const CompleteBundledFlat$25 = 'Complete Bundled $25';
export const BusCon$10OffFor36Months = 'Promotion: Bus Con $10 off for 36 months';
export const BusCon$10OffFor60Months = 'Promotion: Bus Con $10 off for 60 months';
// OdysseyAI edition-specific bundled discount promos (non-Quebec, SMB, 3+ seats, new acquisition).
// Enhanced: $4 off per seat; Complete: $7 off per seat.
export const BusCon$4DiscountOn36Months = 'Promotion: Bus Con - $4 discount on 36 month term';
export const BusCon$4DiscountOn60Months = 'Promotion: Bus Con - $4 discount on 60 month term';
export const BusCon$7OffFor36Months = 'Promotion: Bus Con $7 off for 36 months';
export const BusCon$7OffFor60Months = 'Promotion: Bus Con $7 off for 60 months';
// BCON-2645: BCON AI Complete $5 off promos (term-conditional, non-Quebec, bundled).
export const BusCon$5OffFor36Months = 'Promotion: Bus Con $5 off for 36 months';
export const BusCon$5OffFor60Months = 'Promotion: Bus Con $5 off for 60 months';
// BCON-2645: Regular BCON Complete Bundled $30 (non-Quebec, bundled).
export const CompleteBundled$30 = 'Complete Bundled $30';
export const CompletePromoSeat$33 = 'Complete Promo $33 (1-14 seat account)';
export const CompletePromoSeat$31 = 'Complete Promo $31 (15-24 seat account)';
export const CompletePromoSeat$29 = 'Complete Promo $29 (25-49 seat account)';
export const CompletePromoSeat$27 = 'Complete Promo $27 (50-99 seat account)';
export const CompletePromoSeat$26 = 'Complete Promo $26 (100-199 seat account)';
export const CompletePromoSeat$25 = 'Complete Promo $25 (200+ seat account)';
export const CompletePromo$33 = 'Complete Promo $33';
export const CompletePromo$31 = 'Complete Promo $31';
export const CompletePromo$29 = 'Complete Promo $29';
export const CompletePromo$27 = 'Complete Promo $27';
export const CompletePromo$26 = 'Complete Promo $26';
export const CompletePromo$25 = 'Complete Promo $25';
export const EnhancedBundled26_3MF = 'Enhanced Bundled $26-3MF';
export const CompleteBundled26_3MF = 'Complete Bundled $28-3MF';
export const EnhanceBundled26_3MF_Multi = 'Enhance Bundled $26-3MF (3+ Seats)';
export const CompleteBundled26_3MF_Multi =
  'Complete Bundled $28-3MF (3+ Seats)';
export const multiUnitDiscount$2 = 'Multi-Unit Discount: Bus Con $2';
export const multiUnitDiscount$4 = 'Multi-Unit Discount: Bus Con $4';
export const multiUnitDiscount$6 = 'Multi-Unit Discount: Bus Con $6';
export const multiUnitDiscount$7 = 'Multi-Unit Discount: Bus Con $7';
export const multiUnitDiscount$8 = 'Multi-Unit Discount: Bus Con $8';
export const ALL_USERS = 'All users';
export const INTERNAL_USERS = 'Internal users only';
export const EXTERNAL_USERS = 'External users only';

export const IotOrderTypes = ['Activation', 'Renewal'];
export const IotViewTypes = ['simpleView', 'advancedView'];
export const IotTerm3Year = '3 year';
export const IotTermMTM = 'MTM';
export const IotRaven5CAN_USNon_Share = 'Raven 5 CAN-US Non-Share';
export const IotRaven5CAN_USNon_Share_Price = 76.67;
export const IotRaven5Non_Share = 'Raven 5 Non-Share';
export const IotVisionVideoDataAddOn = 'Vision Video Data Add On';
export const IotVisionVideoDataAddOn10GB= '10GB';
export const IotVisionVideoDataAddOn5GB = '5GB';
export const IotVisionVideoDataAddOn25GB = '25GB';

export const IotRaven = {
  'Raven 5 Non-Share': 'IotRaven5Non_Share',
  'Raven 5 CAN-US Non-Share': 'IotRaven5CAN_USNon_Share'
};
export const IotRaven5Non_Share_Price = 56.67;
export const IotRavenDevice = 'Raven+';
export const IotOBDYSplitter = 'Cable - OBD Y-Splitter';
export const IotProductGeoTab = 'GeoTab';
export const IotProductGeoforce = 'Geoforce';

// List of Enhanced Seat promos available for multi site
export const ENHANCED_SEAT_PROMO_MULTI_SITE = [
  EnhancedPromoSeat$19,
  EnhancedPromoSeat$20,
  EnhancedPromoSeat$22,
  EnhancedPromoSeat$24,
  EnhancedPromoSeat$26,
  EnhanceBundled26_3MF_Multi
];

// List of Enhanced Seat promos available for non multi site
export const ENHANCED_SEAT_PROMO_NON_MULTI_SITE = [
  EnhancedPromo$19,
  EnhancedPromo$20,
  EnhancedPromo$22,
  EnhancedPromo$24,
  EnhancedPromo$26,
  EnhancedBundled26_3MF
];

// Enhanced Promo Seat Mapping
export const ENHANCED_SEAT_PROMO_NON_MULTI_SITE_MAP = {
  [EnhancedPromo$26]: {
    minSeats: 1,
    maxSeats: 14
  },
  [EnhancedPromo$24]: {
    minSeats: 15,
    maxSeats: 24
  },
  [EnhancedPromo$22]: {
    minSeats: 25,
    maxSeats: 49
  },
  [EnhancedPromo$20]: {
    minSeats: 50,
    maxSeats: 99
  },
  [EnhancedPromo$19]: {
    minSeats: 100,
    maxSeats: Infinity
  },
  [EnhancedBundled26_3MF]: {
    minSeats: 3,
    maxSeats: Infinity
  }
};

export const COMPLETE_SEAT_PROMO_MULTI_SITE = [
  CompletePromoSeat$25,
  CompletePromoSeat$26,
  CompletePromoSeat$27,
  CompletePromoSeat$29,
  CompletePromoSeat$31,
  CompletePromoSeat$33,
  CompleteBundled26_3MF_Multi
];

// List of Complete Seat promos available for non multi site
export const COMPLETE_SEAT_PROMO_NON_MULTI_SITE = [
  CompletePromo$25,
  CompletePromo$26,
  CompletePromo$27,
  CompletePromo$29,
  CompletePromo$31,
  CompletePromo$33,
  CompleteBundled26_3MF
];

// Complete Promo Seat Mapping
export const COMPLETE_SEAT_PROMO_NON_MULTI_SITE_MAP = {
  [CompletePromo$33]: {
    minSeats: 1,
    maxSeats: 14
  },
  [CompletePromo$31]: {
    minSeats: 15,
    maxSeats: 24
  },
  [CompletePromo$29]: {
    minSeats: 25,
    maxSeats: 49
  },
  [CompletePromo$27]: {
    minSeats: 50,
    maxSeats: 99
  },
  [CompletePromo$26]: {
    minSeats: 100,
    maxSeats: 199
  },
  [CompletePromo$25]: {
    minSeats: 200,
    maxSeats: Infinity
  },
  [CompleteBundled26_3MF]: {
    minSeats: 3,
    maxSeats: Infinity
  }
};

export const multiUnitDiscountArray = [
  multiUnitDiscount$2,
  multiUnitDiscount$4,
  multiUnitDiscount$6,
  multiUnitDiscount$7,
  multiUnitDiscount$8
];

export const multiUnitDiscountSeatMapping = {
  [multiUnitDiscount$2]: {
    minSeats: 15,
    maxSeats: 24
  },
  [multiUnitDiscount$4]: {
    minSeats: 25,
    maxSeats: 49
  },
  [multiUnitDiscount$6]: {
    minSeats: 50,
    maxSeats: 99
  },
  [multiUnitDiscount$7]: {
    minSeats: 100,
    maxSeats: 199
  },
  [multiUnitDiscount$8]: {
    minSeats: 200,
    maxSeats: Infinity
  }
};

export const powerFleetFieldType = {
  IoTMonthlySoftwarePricing: 'monthlySoftwareSubscription',
  IoTHardwarePowerFleet: 'hardwarePowerFleet',
  IoTProfessionalServices: 'professionalServices',
  IoTProfessionalServicesColdChain: 'professionalServicesColdChain',
  IoTHardwareColdChain: 'hardwareColdChainPowerFleet'
};

export const powerFleetFieldTypeSummary = {
  iotSummaryMonthlySoftwareSubscription: 'monthlySoftwareSubscription',
  iotSummaryHardwarePowerFleet: 'hardwarePowerFleet',
  iotSummaryProfessionalServices: 'professionalServices',
  iotSummaryHardwareColdChainPowerFleet: 'hardwareColdChainPowerFleet',
  iotSummaryProfessionalServicesColdChain: 'professionalServicesColdChain'
};

export const powerFleetFieldTypeSummaryHeading = {
  iotSummaryMonthlySoftwareSubscription: 'Monthly Software Subscription',
  iotSummaryHardwarePowerFleet: 'Hardware',
  iotSummaryProfessionalServices: 'Professional Services',
  iotSummaryHardwareColdChainPowerFleet: 'Hardware',
  iotSummaryProfessionalServicesColdChain: 'Professional Services'
};

export const unitLimitForprofessionalServices = {
  'Whole Day Installation and Support': 19,
  'Flat Rate Shipping': 19,
  'Paid Trial Forklift Gateway Demo': 9,
  'Paid Trial Pedestrian Proximity Camera Demo': 9
};

export const unitLimitForprofessionalServicesColdChain = {
  'Installation and Support': 499,
  'Flat Rate Shipping': 19,
  'Paid Trial Cold Chain Demo Kit': 9
};

export const bulkUploadNewUserFileLink =
  'https://sof1-public-files.s3.ca-central-1.amazonaws.com/Bulk-User-Upload-Template+(MySOF).xlsx';
export const bulkUploadUpdateUserFileLink =
  'https://sof2-public-files.s3.ca-central-1.amazonaws.com/User-Changes-Template.xlsx';

export const esChatDiscountProduct = [
  'Discounted Price(Basic)',
  'Prix Réduit (de base)',
  'Discounted Price(Premium)',
  'Prix réduit (Supérieur)'
];

export const fieldStoreCodeOutletBcon = 'storeCodeOutletBcon';
export const fieldStoreCodeBcon = 'storeCodeBcon';

export const fieldToHideInAdditionalfeaturesSectionForOdysseyAi = [
  fieldTelusBusinessConnectRooms,
  fieldtelusBusinessConnectRoomConnector,
  fieldTelusBusinessConnectLiveReports,
  fieldTelusBusinessConnectLargeMeetings200,
  fieldAdditionalTollFreeNumbers,
  fieldMsftDirectRouting
];

export const singleSelectChatFields = [
  'chatNamedOdysseyAI',
  'chatConcurrentOdysseyAI',
  'contactCentreOdysseyAI',
  'contactCentreConcurrentOdysseyAI'
];

export const chatNameTypes = ['chatNamedOdysseyAI', 'contactCentreOdysseyAI'];

export const chatConcurrentTypes = [
  'chatConcurrentOdysseyAI',
  'contactCentreConcurrentOdysseyAI'
];

export const hideChatFieldsForNamedOdysseyAI = [
  'insightsCentreOdysseyAI',
  'agentAssistOdysseyAI',
  'supervisorAssistOdysseyAI'
];

export const hideChatFieldsForConcurrentOdysseyAI = [
  'insightsCentreConcurrentOdysseyAI',
  'agentAssistConcurrentOdysseyAI',
  'supervisorAssistConcurrentOdysseyAI'
];

export const hideChatFieldsForOdysseyAI = [
  'insightsCentreOdysseyAI',
  'agentAssistOdysseyAI',
  'supervisorAssistOdysseyAI',
  'insightsCentreConcurrentOdysseyAI',
  'agentAssistConcurrentOdysseyAI',
  'supervisorAssistConcurrentOdysseyAI'
];

export const allAdditionalFeaturesOfOdysseyAIValidationField = [
  ...singleSelectChatFields,
  ...hideChatFieldsForOdysseyAI,
  'insightsOdysseyAI'
];

// AI features to hide for SMB 1-30 and SMB 30-100 segments
// Only AI Receptionist and AI Insights should be visible for these segments
export const hideAIFeaturesForSMBSegments = [
  'chatNamedOdysseyAI',
  'chatConcurrentOdysseyAI',
  'contactCentreOdysseyAI',
  'contactCentreConcurrentOdysseyAI',
  'insightsCentreOdysseyAI',
  'insightsCentreConcurrentOdysseyAI',
  'agentAssistOdysseyAI',
  'agentAssistConcurrentOdysseyAI',
  'supervisorAssistOdysseyAI',
  'supervisorAssistConcurrentOdysseyAI'
];

/**
 * AI Odyssey edition-based feature visibility.
 *
 * Editions: Mobile, Voice, Voice Plus, Enhanced, Complete.
 * The fields listed below (AI Insights + Contact Centre suite) must only be
 * available for Voice Plus, Enhanced and Complete editions; they should be
 * hidden (and their values cleared) when the edition is Mobile or Voice.
 */
export const odysseyAiVoicePlusOnlyBaseFields = [
  'insightsOdysseyAI',
  ...hideAIFeaturesForSMBSegments
];

export const isOdysseyAiVoicePlusOnlyFieldName = fieldName =>
  typeof fieldName === 'string' &&
  odysseyAiVoicePlusOnlyBaseFields.some(
    base => fieldName === base || fieldName.startsWith(`${base}_`)
  );

/** Clear Voice Plus+ Odyssey field values when edition is Mobile or Voice. Mutates `fields`. */
export const clearOdysseyAiVoicePlusOnlyFields = fields => {
  if (!fields) return;
  Object.keys(fields).forEach(key => {
    if (!isOdysseyAiVoicePlusOnlyFieldName(key)) return;
    const matchField = fields[key];
    if (!matchField || typeof matchField !== 'object') return;
    if (matchField.checked) {
      matchField.checked = false;
    }
    if (matchField.value) {
      matchField.value = undefined;
    }
  });
};

export const fieldAssistantOdysseyAI = 'assistantOdysseyAI';
export const fieldassistantOdysseyAIOdysseyAI = 'assistantOdysseyAI_OdysseyAI';
export const fieldAssistantAiOdysseyAI = 'assistantAiOdysseyAI';
export const fieldAssistantAiOdysseyAIOdysseyAI = 'assistantAiOdysseyAI_OdysseyAI';
export const odysseyAiSupervisorSyncTriggerFields = [
  'chatNamedOdysseyAI',
  'chatNamedOdysseyAI_OdysseyAI',
  'contactCentreOdysseyAI',
  'contactCentreOdysseyAI_OdysseyAI',
  'chatConcurrentOdysseyAI',
  'chatConcurrentOdysseyAI_OdysseyAI',
  'contactCentreConcurrentOdysseyAI',
  'contactCentreConcurrentOdysseyAI_OdysseyAI',
  'supervisorAssistOdysseyAI',
  'supervisorAssistConcurrentOdysseyAI',
  'supervisorAssistOdysseyAI_OdysseyAI',
  'supervisorAssistConcurrentOdysseyAI_OdysseyAI'
];
export const limitedExtensionOdysseyAIOdysseyAI =
  'limitedExtensionOdysseyAI_OdysseyAI';
// AI flow: AI Receptionist / AI Insights components and their Install
// checkboxes (dealer direct billing). The Install checkbox is enabled only when
// its component is selected AND its *_OdysseyAI value is present.
export const fieldReceptionistOdysseyAI = 'receptionistOdysseyAI';
export const fieldReceptionistOdysseyAIOdysseyAI =
  'receptionistOdysseyAI_OdysseyAI';
export const fieldInsightsOdysseyAI = 'insightsOdysseyAI';
export const fieldInsightsOdysseyAIOdysseyAI = 'insightsOdysseyAI_OdysseyAI';
export const fieldReceptionistInstall = 'receptionistInstall';
export const fieldInsightsInstall = 'insightsInstall';
export const fieldSigningEmailAuthority = 'signingEmailAuthority';
